<template>
    <v-container fluid class="pa-0">
    <v-card style="position: absolute; width: 100%">
        <v-card-title>
            <div class="mr-3">{{$t('event.useful-information')}}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddUsefulInformation">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="tableUsefulInformation"
            :loading="isUsefulInformationPending"
            @pagination="currentPagination"
        >
            <template v-slot:item.scroller="{value}">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.order="{value}">
                {{value}}
            </template>
            <template v-slot:item.tags="{value}">
                {{JSON.parse(value).toString()}}
            </template>
            <template v-slot:item.content="{value}">
                <froalaView v-model="value" class="popup-preview"></froalaView>
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn
                    color="primary"
                    class="ma-2"
                    :disabled="isEditOrderMode"
                    @click="initEditUsefulInformation(item)"
                >{{$t('edit')}}<v-icon right>mdi-pencil</v-icon></v-btn>
                <v-btn
                    color="red"
                    :dark="!isEditOrderMode"
                    class="ma-2"
                    :disabled="isEditOrderMode"
                    @click="deleteUsefulInformation(item)"
                >{{$t('delete')}}<v-icon right>mdi-delete</v-icon></v-btn>
            </template>
        </v-data-table>

        <v-dialog
            v-model="editUsefulInformationDialogShown"
            max-width="600px"
            persistent
            scrollable
            :retain-focus="false"
        >
            <v-card>
                <v-card-title>
                    {{$t('event.useful-information')}}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditUsefulInformationFormValid">
                            <template>
                                <v-combobox
                                    v-model="tagsSelected"
                                    :items="tagsItems"
                                    small-chips
                                    clearable
                                    :label="$t('event_useful_information.tags')"
                                    multiple
                                    outlined
                                    hide-selected
                                >
                                    <template v-slot:selection="{ attrs, item, select, selected }">
                                    <v-chip
                                        v-bind="attrs"
                                        :input-value="selected"
                                        close
                                        small
                                        color="primary"
                                        @click="select"
                                        @click:close="remove(item)"
                                    >
                                        <strong>{{ item }}</strong>&nbsp;
                                    </v-chip>
                                    </template>
                                </v-combobox>
                            </template>
                            <!-- <v-row>
                                <v-file-input
                                    accept="image/*"
                                    :label="$t('event_useful_information.picture')"
                                    v-model="editingUsefulInformation.picture"
                                >
                                    <template v-slot:selection="{file}">
                                        <v-img
                                            :src="getFileUrl(file)"
                                            max-width="250px"
                                            max-height="250px"
                                        ></v-img>
                                    </template>
                                </v-file-input>
                            </v-row> -->
                            <v-row>
                                <v-col class="pb-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.title')"
                                        :placeholder="$t('event_useful_information.title')"
                                        v-model="editingUsefulInformation.title"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field 
                                        outlined
                                        :label="$t('event_useful_information.title_tc')"
                                        :placeholder="$t('event_useful_information.title_tc')"
                                        v-model="editingUsefulInformation.title_tc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.title_sc')"
                                        :placeholder="$t('event_useful_information.title_sc')"
                                        v-model="editingUsefulInformation.title_sc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.address')"
                                        :placeholder="$t('event_useful_information.address')"
                                        v-model="editingUsefulInformation.address"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.address_tc')"
                                        :placeholder="$t('event_useful_information.address_tc')"
                                        v-model="editingUsefulInformation.address_tc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.address_sc')"
                                        :placeholder="$t('event_useful_information.address_sc')"
                                        v-model="editingUsefulInformation.address_sc"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.key')"
                                        :placeholder="$t('event_useful_information.key')"
                                        v-model="editingUsefulInformation.key"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.type')"
                                        :placeholder="$t('event_useful_information.type')"
                                        v-model="editingUsefulInformation.type"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.mapId')"
                                        :placeholder="$t('event_useful_information.mapId')"
                                        v-model="editingUsefulInformation.mapId"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        :label="$t('event_useful_information.offer')"
                                        :placeholder="$t('event_useful_information.offer')"
                                        v-model="editingUsefulInformation.offer"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_useful_information.content')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingUsefulInformation.content"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_useful_information.content_tc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingUsefulInformation.content_tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_useful_information.content_sc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingUsefulInformation.content_sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_useful_information.openingHours')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingUsefulInformation.openingHours"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">{{$t('event_useful_information.reservation')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingUsefulInformation.reservation"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="confirmSaveItemDialogShown = true" :disabled="!isEditUsefulInformationFormValid">{{$t('save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <PopupAlert 
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditUsefulInformationItem"
            :onNo="function() {confirmCancelItemDialogShown=false;}"
        ></PopupAlert>
        <PopupAlert 
            v-model="confirmSaveItemDialogShown"
            title="Confirm"
            message="Do you wish to confirm to save your useful information?"
            :onYes="saveUsefulInformation"
            :onNo="function() {confirmSaveItemDialogShown=false;}"
        ></PopupAlert>
    </v-card>
    </v-container>
</template>

<style scoped>
    .button-spacer {
        width:10px;
    }
</style>

<script>
    import {computed, ref, onMounted} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import {cloneDeep, uniq} from "lodash";
    import PopupAlert from "../../components/PopupAlert";
    import Sortable from "sortablejs";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventUsefulInformation',
        components:{PopupAlert},
        setup(props, {root}) {
            const {EventUsefulInformation} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const eventId = computed(() => root.$route.params.eventId);

            const usefulInformationParams = computed(() => {
                return {
                    query: {
                        eventId: eventId.value,
                        $sort: {order: 1},
                    }
                }
            });
            const {items: usefulInformationItems, isPending: isUsefulInformationPending} = useFind({
                model: EventUsefulInformation,
                params: usefulInformationParams,
            });
            // Data Table
            const headers = ref([
                {text: '', value: 'scroller', width: 80},
                {text: root.$t('event_useful_information.order'), value: 'order'},
                {text: root.$t('event_useful_information.tags'), value: 'tags'},
                {text: root.$t('event_useful_information.title'), value: 'title'},
                {text: root.$t('event_useful_information.key'), value: 'key'},
                {text: root.$t('event_useful_information.content'), value: 'content', width: '300px'},
                {text: '', value: 'actions'},
            ]);

            // Order
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const editOrderUsefulInformation = ref([]);
            const overlay = ref(false);
            const tagsSelected = ref([]);
            const tagsItems = ref([]);

            // Add / Edit UsefulInformation
            const editUsefulInformationDialogShown = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const confirmSaveItemDialogShown = ref(false);
            const isEditUsefulInformationFormValid = ref(false);
            const editingUsefulInformation = ref(new EventUsefulInformation({eventId: eventId.value}));
            const initAddUsefulInformation = function () {
                editingUsefulInformation.value = new EventUsefulInformation({eventId: eventId.value});
                editingUsefulInformation.value.order = usefulInformationItems.value.length + 1;
                editUsefulInformationDialogShown.value = true;
                for (let i = 0; i < usefulInformationItems.value.length; i++) {
                    if (usefulInformationItems.value[i].tags) {
                        tagsItems.value.push(...JSON.parse(usefulInformationItems.value[i].tags));
                    }
                }
                tagsItems.value = uniq(tagsItems.value);
                tagsSelected.value = [];
            };
            const initEditUsefulInformation = function (usefulInformation) {
                editingUsefulInformation.value = cloneDeep(usefulInformation);
                editUsefulInformationDialogShown.value = true;
                for (let i = 0; i < usefulInformationItems.value.length; i++) {
                    if (usefulInformationItems.value[i].tags) {
                        tagsItems.value.push(...JSON.parse(usefulInformationItems.value[i].tags));
                    }
                }
                tagsItems.value = uniq(tagsItems.value);
                tagsSelected.value = editingUsefulInformation.value.tags ? JSON.parse(editingUsefulInformation.value.tags) : [];
            };
            const deleteUsefulInformation = function (usefulInformation) {
                if (confirm(root.$t('event_useful_information.confirm_delete'))) {
                    usefulInformation.remove();
                }
            };
            const saveUsefulInformation = async function () {
                if( editingUsefulInformation.value.picture instanceof File){
                    editingUsefulInformation.value.picture = {src:await root.$uploadFile(editingUsefulInformation.value.picture)};
                }
                if (!editingUsefulInformation.value.picture) {
                    editingUsefulInformation.value.picture = null;
                }

                editingUsefulInformation.value.tags = JSON.stringify(tagsSelected.value);

                editingUsefulInformation.value.save().then(() => {
                    EventUsefulInformation.get(editingUsefulInformation.value.id);
                    editUsefulInformationDialogShown.value = false;
                    confirmSaveItemDialogShown.value = false;
                    root.$store.dispatch('showSnackBar', root.$t('event_useful_information.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            const cancelEditUsefulInformationItem = function(){
                editUsefulInformationDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
            }

            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderUsefulInformation.value = cloneDeep(sortedUsefulInformation.value)
            }

            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                console.log("editOrderUsefulInformation:",editOrderUsefulInformation.value)
                for(let i=0;i<editOrderUsefulInformation.value.length;i++){
                    await editOrderUsefulInformation.value[i].save().then(()=>{
                        EventUsefulInformation.get(editOrderUsefulInformation.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }
            const quickSortUsefulInformation = function(sortUsefulInformation){
                if(sortUsefulInformation.length<2){
                    return sortUsefulInformation
                }

                const chosenIndex = sortUsefulInformation.length - 1
                const chosen  = sortUsefulInformation[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortUsefulInformation[i].order
                    temp < chosen.order ? a.push(sortUsefulInformation[i]) : b.push(sortUsefulInformation[i])
                }
                const output = [...quickSortUsefulInformation(a),chosen,...quickSortUsefulInformation(b)]
                return output
            }

            const sortedUsefulInformation = computed(()=>{
                return quickSortUsefulInformation(usefulInformationItems.value)
            })
            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderUsefulInformation.value.splice(oldIndex,1)[0];
                            editOrderUsefulInformation.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderUsefulInformation.value.length;i++){
                                editOrderUsefulInformation.value[i].order = i+1
                            }
                            editOrderUsefulInformation.value = quickSortUsefulInformation(editOrderUsefulInformation.value);
                        }
                    }
                )
            });

            const tableUsefulInformation = computed(()=>{
                return isEditOrderMode.value?editOrderUsefulInformation.value:sortedUsefulInformation.value
            })

            const remove = (item) => {
                tagsSelected.value.splice(tagsSelected.value.indexOf(item), 1);
            }

            return {
                usefulInformationItems,
                isUsefulInformationPending,

                headers,
                tableUsefulInformation,

                editUsefulInformationDialogShown,
                confirmCancelItemDialogShown,
                confirmSaveItemDialogShown,
                initAddUsefulInformation,
                initEditUsefulInformation,
                deleteUsefulInformation,
                isEditUsefulInformationFormValid,
                editingUsefulInformation,
                saveUsefulInformation,
                cancelEditUsefulInformationItem,

                DateTime,
                getFileUrl: root.$getFileURL,

                previewHtmlContentOption,
                currentPagination,

                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                isEditOrderMode,
                overlay,
                tagsSelected,
                tagsItems,
                remove,

                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 2000
                },
                showEditor,
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>
